// extracted by mini-css-extract-plugin
export default {"cont":"BotScript_cont__uPorb","buttonCont":"BotScript_buttonCont__nrQRT"};